export default "__VITE_ASSET__ab3d7845__"